// THE STUDIOCORE RIBBON — two-row assembly (R0 skeleton, 2026-07-20;
// R1 host extensions same day).
//
// CONCEPT-text-ribbon §1: Row 1 = "the words" (MORPHS by selection kind via
// the rowset registry); Row 2 = "the thing on the page" (universal, identical
// for every object type, forever). R1 mounts Row 2 into the live editor
// (RibbonMount.jsx); the lab renders both rows.
//
// HOST CONTRACT (what a mount provides — nothing else):
//   selectionKind  'text' | 'shape' | 'image' | 'none'   (derived from mirrors)
//   state          flat mirror bag — useSelectionProps vocabulary + ribbon
//                  additions (scope, dots…); read-only here
//   handlers       flat { 'namespace.verb': fn } — the handler-key resolution
//                  table (see rowsets/textRow1.mjs for the full key list)
//   onOpenDrawer   (sectionId) => void — the drawer-link contract
//   density        'normal' | 'touch' — smartboard mode (§4.6); scales hit
//                  targets via CSS custom properties only (same layout, same
//                  order; a settings toggle later per decision §6.5)
//   rows           which rows to render, default [1, 2]. R1 mounts Row 2
//                  alone ([2]) while the old top toolbar still plays Row 1;
//                  R2 flips the live mount to [1, 2] and this prop stays as
//                  the phase seam (the lab always renders both).
//   disabledGroupIds  group ids rendered DISABLED (fieldset-disabled controls,
//                  dimmed caption, menus unopenable). The host owns the
//                  POLICY (e.g. object-scoped groups with no selection); the
//                  ribbon only executes it. Page-scoped groups are simply
//                  never listed.
//
// THE HISTORY CLUSTER MOVED OUT (app-bar lane B0, 2026-07-21 — owner: "The
// undo and redo buttons are completely out of place… build an always visible
// small ribbon above the current 2"): the persistent Undo/Redo pair lives in
// BAR 0 now (AppBar.jsx, rendered by RibbonMount above this component) with
// the same markup contract (.rbn-history-btn[data-verb], Ctrl+Z/Ctrl+Y
// tooltips), the same undoAvailable/redoAvailable mirrors and the same
// 'history.undo'/'history.redo' keys. This component is the two morphing
// rows and NOTHING else — the lab renders it bare, the live mount stacks
// Bar 0 on top.
import React from 'react';
import RibbonRow from './core/RibbonRow';
import { getRow1Rowset, getRow2Rowset } from './core/rowsetRegistry.mjs';

export default function Ribbon({
  selectionKind = 'none',
  state = {},
  handlers = {},
  onOpenDrawer,
  density = 'normal',
  rows = [1, 2],
  disabledGroupIds,
}) {
  const row1 = getRow1Rowset(selectionKind);
  const row2 = getRow2Rowset();
  const disabled = disabledGroupIds instanceof Set
    ? disabledGroupIds
    : new Set(disabledGroupIds || []);

  return (
    <div
      className="rbn-root"
      data-tour="editor-ribbon"
      data-density={density}
      data-selection-kind={selectionKind}
      data-rows={rows.join(',')}
    >
      <div className="rbn-rows">
        {rows.includes(1) && (
          <RibbonRow
            rowId="row1"
            rowset={row1}
            state={state}
            handlers={handlers}
            onOpenDrawer={onOpenDrawer}
            disabledGroupIds={disabled}
          />
        )}
        {rows.includes(2) && (
          <RibbonRow
            rowId="row2"
            rowset={row2}
            state={state}
            handlers={handlers}
            onOpenDrawer={onOpenDrawer}
            disabledGroupIds={disabled}
          />
        )}
      </div>
    </div>
  );
}
